import {
  Modal,
  StyleSheet,
  FlatList,
  Image,
  TouchableOpacity,
  TextInput,
  View,
  Text,
} from "react-native";
import React, { useRef, useState } from "react";

import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import { toast } from "react-toastify";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";

export default function GoLiveChatModal(props) {
  const styles = useStyles();
  const { chatData, setChatData, isVisible, onClose } = props;
  const [selectedButton, setSelectedButton] = useState("Players");
  const flatListRef = useRef(null);
  const [newMessage, setNewMessage] = useState("");
  const sendMessage = () => {
    if (newMessage === "") {
      toast.error("Please enter message");
      return;
    }
    const newChatData = {
      key: "1",
      userId: "Test",
      message: newMessage,
    };

    setChatData((prevChatData) => [...prevChatData, newChatData]);
    setNewMessage("");
    flatListRef.current.scrollToEnd({ animated: true });
  };
  const renderChatMessages = ({ item, index }) => {
    if (item.userId === "Pri3") {
      return (
        <View
          style={{
            flex: 1,
          }}
        >
          <View style={styles.senderMainWrapper}>
            <View
              style={{
                backgroundColor: AppColors.purpleColor_9D2CF5,
                width: 32,
                height: 32,
                borderRadius: 100,
                alignSelf: "flex-end",
              }}
            />
            <View style={styles.senderChatWrapper}>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  { color: AppColors.black_1D072D, flex: 1 },
                ]}
              >
                {item.message}
              </Text>
            </View>
          </View>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_12,
              { paddingTop: 10, opacity: 0.4, alignSelf: "flex-start" },
            ]}
          >
            12:20 AM
          </Text>
        </View>
      );
    } else {
      return (
        <View
          style={{
            marginVertical: 10,
          }}
        >
          <View
            style={{
              marginStart: "35%",
              alignSelf: "flex-end",
              paddingHorizontal: 12,
              paddingVertical: 10,
              borderTopEndRadius: 10,
              borderBottomStartRadius: 10,
              borderTopStartRadius: 10,
              backgroundColor: AppColors.purpleColor_9D2CF5,
              shadowColor: "#ccc",
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.25,
              shadowRadius: 2,
              elevation: 1,
            }}
          >
            <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>
              {item.message}
            </Text>
          </View>
          <View
            style={{
              flex: 1,
              gap: 8,
              flexDirection: "row",
              marginTop: 10,
              alignSelf: "flex-end",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Image
              source={AppImages.icTick}
              style={{ height: 16, width: 16, resizeMode: "contain" }}
            />
            <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>12:20 AM</Text>
          </View>
        </View>
      );
    }
  };
  return (
    <Modal transparent={true} visible={isVisible}>
      <View style={styles.container}>
        <TouchableOpacity
          onPress={onClose}
          style={{
            borderWidth: 1.8,
            borderColor: AppColors.white,
            borderRadius: 10,
            height: 30,
            width: 30,
            alignSelf: "flex-end",
            backgroundColor: AppColors.gray_1E1E1E,
            //   top:100,
            margin: 10,
          }}
        >
          <Image
            source={AppImages.icCancel}
            style={{
              height: 12,
              width: 12,
              alignSelf: "center",
              marginVertical: 7,
            }}
            resizeMode="contain"
          />
        </TouchableOpacity>
        <View style={styles.mainView}>
          <View
            style={{
              marginTop: 10,
              flexDirection: "row",
              backgroundColor: AppColors.grayColor_505050,
              borderRadius: 10,
              justifyContent: "space-between",
            }}
          >
            <TouchableOpacity
              onPress={() => {
                setSelectedButton("Players");
              }}
              style={[
                styles.btnTeam,
                {
                  backgroundColor:
                    selectedButton === "Players"
                      ? AppColors.gray_1E1E1E
                      : AppColors.grayColor_333333,
                  borderRadius: 10,
                },
              ]}
            >
              <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>Players</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                setSelectedButton("Captains");
              }}
              style={[
                styles.btnTeam,
                {
                  backgroundColor:
                    selectedButton === "Captains"
                      ? AppColors.gray_1E1E1E
                      : AppColors.grayColor_333333,
                  borderRadius: 10,
                },
              ]}
            >
              <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>Captains</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                setSelectedButton("Moderator");
              }}
              style={[
                styles.btnTeam,
                {
                  backgroundColor:
                    selectedButton === "Moderator"
                      ? AppColors.gray_1E1E1E
                      : AppColors.grayColor_333333,
                  borderRadius: 10,
                },
              ]}
            >
              <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>Moderator</Text>
            </TouchableOpacity>
          </View>
          <View
            style={{
              borderColor: AppColors.white,
              borderWidth: 1,
              borderRadius: 10,
              flex: 1,
              marginTop: 15,
              padding: 10,
            }}
          >
            <FlatList
              data={chatData}
              renderItem={renderChatMessages}
              ref={flatListRef}
            />

            <View
              style={{
                height: 2,
                backgroundColor: AppColors.gray_A3A3A3,
                marginBottom: 7,
                marginTop: 10,
              }}
            />
            <View style={{ flexDirection: "row", marginTop: 8, columnGap: 10 }}>
              <TextInput
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    flex: 1,
                    backgroundColor: "white",
                    borderRadius: 10,
                    paddingHorizontal: 7,
                    paddingVertical: 15,
                    justifyContent: "center",
                    alignItems: "center",
                    color: "black",
                  },
                ]}
                multiline={true}
                placeholderTextColor="#989898 "
                placeholder="Write your message..."
                value={newMessage}
                onChangeText={setNewMessage}
              />
              <TouchableOpacity
                onPress={sendMessage}
                style={{
                  backgroundColor: AppColors.purpleColor_9D2CF5,
                  height: 60,
                  width: 60,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 10,
                }}
              >
                <Image
                  source={AppImages.arrowUp}
                  style={{
                    height: 32,
                    width: 32,
                    resizeMode: "contain",
                    marginVertical: 10,
                  }}
                />
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      backgroundColor: AppColors.blackTrans_000000a8,
      flex: 1,
    },
    mainView: {
      flex: 1,
      borderWidth: 1,
      backgroundColor: AppColors.gray_1E1E1E,
      borderColor: AppColors.grayColor_505050,
      padding: 10,
      borderRadius: 10,
      marginVertical: "30%",
      marginHorizontal: "20%",
    },
    btnTeam: {
      paddingVertical: 15,
      paddingHorizontal: 10,
      margin: 10,
    },
    senderMainWrapper: {
      flex: 1,
      width: "100%",
      flexDirection: "row",
      marginTop: 8,
      columnGap: 8,
      alignSelf: "flex-start",
    },
    senderChatWrapper: {
      maxWidth: "65%",
      marginEnd: "35%",
      padding: 10,
      borderTopEndRadius: 10,
      borderTopStartRadius: 10,
      borderBottomEndRadius: 10,
      backgroundColor: "#e2e2e2",
      shadowColor: "#ccc",
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.25,
      shadowRadius: 2,
      elevation: 1,
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      container: {
        backgroundColor: AppColors.blackTrans_000000a8,
        flex: 1,
      },
      mainView: {
        flex: 1,
        borderWidth: 1,
        backgroundColor: AppColors.gray_1E1E1E,
        borderColor: AppColors.gray_A3A3A3,
        padding: 10,
        borderRadius: 10,
        marginVertical: "22%",
        marginHorizontal: "3%",
      },
      senderMainWrapper: {
        flex: 1,
        width: "100%",
        flexDirection: "row",
        marginTop: 8,
        columnGap: 8,
        alignSelf: "flex-start",
      },
      senderChatWrapper: {
        maxWidth: "65%",
        marginEnd: "35%",
        padding: 10,
        borderTopEndRadius: 10,
        borderTopStartRadius: 10,
        borderBottomEndRadius: 10,
        backgroundColor: "#e2e2e2",
        shadowColor: "#ccc",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 2,
        elevation: 1,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        backgroundColor: AppColors.blackTrans_000000a8,
        flex: 1,
      },
      mainView: {
        flex: 1,
        borderWidth: 1,
        backgroundColor: AppColors.gray_1E1E1E,
        borderColor: AppColors.grayColor_505050,
        padding: 10,
        borderRadius: 10,
        marginVertical: "15%",
        marginHorizontal: "20%",
      },

      senderMainWrapper: {
        flex: 1,
        width: "100%",
        flexDirection: "row",
        marginTop: 8,
        columnGap: 8,
        alignSelf: "flex-start",
      },
      senderChatWrapper: {
        maxWidth: "65%",
        marginEnd: "35%",
        padding: 10,
        borderTopEndRadius: 10,
        borderTopStartRadius: 10,
        borderBottomEndRadius: 10,
        backgroundColor: "#e2e2e2",
        shadowColor: "#ccc",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 2,
        elevation: 1,
      },
    },

    [DEVICE_SIZES.MD]: {
      container: {
        backgroundColor: AppColors.blackTrans_000000a8,
        flex: 1,
      },
      mainView: {
        flex: 1,
        borderWidth: 1,
        backgroundColor: AppColors.gray_1E1E1E,
        borderColor: AppColors.gray_A3A3A3,
        padding: 10,
        borderRadius: 10,
        marginVertical: "20%",
        marginHorizontal: "15%",
      },
      senderMainWrapper: {
        flex: 1,
        width: "100%",
        flexDirection: "row",
        marginTop: 8,
        columnGap: 8,
        alignSelf: "flex-start",
      },
      senderChatWrapper: {
        maxWidth: "65%",
        marginEnd: "35%",
        padding: 10,
        borderTopEndRadius: 10,
        borderTopStartRadius: 10,
        borderBottomEndRadius: 10,
        backgroundColor: "#e2e2e2",
        shadowColor: "#ccc",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 2,
        elevation: 1,
      },
    },
  }
);
